module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 151.706f8864.png";